import {createSlice} from "@reduxjs/toolkit";
import {addError} from "src/slices/errors";
import {getTenantDetails, getTenantOrderList, getTenantSubTenantList, getTenantUserList} from "src/api/tenant";

const initialState = {
    currentTenant: {},
    parentTenant: {},
    loadingCurrentTenant: false,
    tenantList: {list: [], totalElements: 0, pageNumber: 0, totalPages: 0},
    loadingTenantList: false,
    userList: {list: [], totalElements: 0, pageNumber: 0, totalPages: 0},
    loadingUserList: false,
    orderList: {list: [], totalElements: 0, pageNumber: 0, totalPages: 0},
    loadingOrderList: false,
    isModalOpen: false,
    selectedTenantId: null,
    isEditTenantStarted: false,
    isDeleteTenantStarted: false,
    isCreateTenantStarted: false
};

const slice = createSlice({
    name: "tenant",
    initialState,
    reducers: {
        setLoadingCurrentTenant(state, action) {
            state.loadingCurrentTenant = action.payload;
        },
        setCurrentTenant(state, action) {
            const {currentTenant, parentTenant} = action.payload;
            state.currentTenant = currentTenant;
            state.parentTenant = parentTenant;
        },

        setLoadingTenantList(state, action) {
            state.loadingTenantList = action.payload;
        },
        setTenantList(state, action) {
            const {tenantList} = action.payload;
            state.tenantList = tenantList;
        },

        setLoadingUserList(state, action) {
            state.loadingUserList = action.payload;
        },
        setUserList(state, action) {
            const {userList} = action.payload;
            state.userList = userList;
        },

        setLoadingOrderList(state, action) {
            state.loadingOrderList = action.payload;
        },
        setOrderList(state, action) {
            const {orderList} = action.payload;
            state.orderList = orderList;
        },

        openDeleteModal(state, action) {
            const {tenantId} = action.payload;
            state.selectedTenantId = tenantId;
            state.isModalOpen = true;
        },

        closeDeleteModal(state) {
            state.selectedTenant = null;
            state.isModalOpen = false;
        },
        setEditingTenant(state, action) {
            const {isStarted} = action.payload;
            state.isEditTenantStarted = isStarted;
        },
        setDeletingTenant(state, action) {
            const {isStarted} = action.payload;
            state.isDeleteTenantStarted = isStarted;
        },
        setCreatingTenant(state, action) {
            const {isStarted} = action.payload;
            state.isCreateTenantStarted = isStarted;
        }
    }
});

export const reducer = slice.reducer;

export const getCurrentTenant = tenantId => async dispatch => {
    dispatch(slice.actions.setLoadingCurrentTenant(true));

    let currentTenant = initialState.currentTenant;
    let parentTenant = initialState.parentTenant;

    let tenantList = initialState.tenantList;
    dispatch(slice.actions.setTenantList({tenantList}));

    let userList = initialState.userList;
    dispatch(slice.actions.setUserList({userList}));

    try {
        const getTenantResponse = await getTenantDetails(tenantId);
        currentTenant = getTenantResponse.data;
        if (currentTenant.parentTenantId) {
            try {
                const getParentTenantResponse = await getTenantDetails(currentTenant.parentTenantId);
                parentTenant = getParentTenantResponse.data;
            } catch (e) {
            }
        }
    } catch (error) {
        dispatch(addError(error));
    }

    dispatch(slice.actions.setCurrentTenant({currentTenant, parentTenant}));
    dispatch(slice.actions.setLoadingCurrentTenant(false));
};

export const getTenantList = (tenantId, query, type, page, limit, sortBy, sortDir) => async dispatch => {
    dispatch(slice.actions.setLoadingTenantList(true));

    let tenantList = initialState.tenantList;

    try {
        const response = await getTenantSubTenantList(tenantId, query, type, page, limit, sortBy, sortDir);
        tenantList = response.data;
    } catch (error) {
        dispatch(addError(error));
    }

    dispatch(slice.actions.setTenantList({tenantList}));
    dispatch(slice.actions.setLoadingTenantList(false));
};

export const getUserList = (tenantId, query, role, page, limit, sortBy, sortDir) => async dispatch => {
    dispatch(slice.actions.setLoadingUserList(true));

    let userList = initialState.userList;

    try {
        const response = await getTenantUserList(tenantId, query, role, page, limit, sortBy, sortDir);
        userList = response.data;
    } catch (error) {
        dispatch(addError(error));
    }

    dispatch(slice.actions.setUserList({userList}));
    dispatch(slice.actions.setLoadingUserList(false));
};

export const getOrderList = (tenantId, query, productCode, status, page, limit, sortBy, sortDir) => async dispatch => {
    dispatch(slice.actions.setLoadingOrderList(true));

    let orderList = initialState.orderList;

    try {
        const response = await getTenantOrderList(tenantId, query, productCode, status, page, limit, sortBy, sortDir);
        orderList = response.data;
    } catch (error) {
        dispatch(addError(error));
    }

    dispatch(slice.actions.setOrderList({orderList}));
    dispatch(slice.actions.setLoadingOrderList(false));
};

export const openDeleteModal = tenantId => dispatch => {
    dispatch(slice.actions.openDeleteModal({tenantId}));
};

export const closeDeleteModal = () => dispatch => {
    dispatch(slice.actions.closeDeleteModal());
};

export const setCreatingTenant = isStarted => dispatch => {
    dispatch(slice.actions.setCreatingTenant({isStarted}));
};

export const setEditingTenant = isStarted => dispatch => {
    dispatch(slice.actions.setEditingTenant({isStarted}));
};

export const setDeletingTenant = isStarted => dispatch => {
    dispatch(slice.actions.setDeletingTenant({isStarted}));
};

export default slice;
